<template>
  <div>
    <div class="border border-1 border-dark mx-2">
      <p class="tituloColorMas mb-0 pb-0 ms-2 mt-1">SALDOS POR PERIODO</p>
      <p class="mt-0 pt-0 ms-2 mb-1 text-secondary tamaños">REPORTE</p>
    </div>
    <div class="border border-1 mx-2 mt-2 pt-2 pb-2 px-3">
      <div class="row">
        <div class="col col-3">
          <label for="">Empresa:</label>
          <select class="form-select tamaño ms-1 container" aria-label="Default select example"
            @change="empresaRuc = $event.target.value">
            <option disabled selected>Seleccionar Empresa..</option>
            <option v-for="Empresa in Empresas" :key="Empresa.id" :value="Empresa.empRuc">
              {{ Empresa.empRazSocial }}
            </option>
          </select>
        </div>

        <div class="col col-3">
          <label> Ejercicio:</label>
          <!-- <select class="form-select tamaño ms-1 container" aria-label="Default select example"
            @change="periodo = $event.target.value">
            <option disabled selected>Seleccionar Año..</option>
            <option v-for="años in ListaAños" :key="años.id" :value="años.año">
              {{ años.año }}
            </option>
          </select> -->

          <select  @change="periodo = $event.target.value" class="form-select tamaño ms-1 container">
            <option disabled selected >-- SELECCIONAR AÑO --</option>
            <option v-for="año in años" :key="año.value" :value="año.value">
              {{ año.label }}
            </option>
          </select>

        </div>

        <div class="col col-6">
          <div class="row gx-5">
            <div class="col col-1">
              <button class="btn btn-success mt-3" @click="descargarReporte" :disabled="isdisabled"
                title="Reporte de saldo por periodo">
                <i class="bi bi-filetype-xlsx"></i>
              </button>
            </div>

            <div class="col col-1">
              <button class="btn btn-success mt-3" @click="descargarReporte1" :disabled="isdisabled"
                title="Reporte de saldo por periodo agrupado">
                <i class="bi bi-filetype-xlsx"></i>
              </button>
            </div>

            <div class="col col-1">
              <button class="btn btn-success mt-3" @click="descargarReporte2" :disabled="isdisabled"
                title="Reporte de saldo por periodo agrupado por todas las empresas">
                <i class="bi bi-filetype-xlsx"></i>
              </button>
            </div>


            <div class="col col-1">
              <button class="btn btn-success mt-3" @click="descargarReporte3" :disabled="isdisabled"
                title="Reporte de saldo por periodo agrupado por todas las empresas">
                <i class="bi bi-filetype-xlsx"></i>
              </button>
            </div>

            <div class="col col-1">
              <button class="btn btn-success mt-3" @click="descargarReporte4" :disabled="isdisabled"
                title="Reporte de saldo por periodo agrupado por todas las empresas">
                <i class="bi bi-filetype-xlsx"></i>
              </button>
            </div>
          </div>
        </div>
        <div class="mt-2">
          <label for="" v-if="cargando">Reporte de saldo por periodo</label>
          <b-progress v-if="cargando" :value="progress" :max="100" show-progress animated>
            <b-progress-bar :value="progress" :label="`${progress}%`"></b-progress-bar>
          </b-progress>


          <label class="mt-3" for="" v-if="cargando1">Reporte de saldo por periodo agrupado</label>
          <b-progress class="" v-if="cargando1" :value="progress1" :max="100" show-progress animated>
            <b-progress-bar :value="progress1" :label="`${progress1}%`"></b-progress-bar>
          </b-progress>


          <label for="" class="mt-3" v-if="cargando2">Reporte de saldo por periodo agrupado por todas las
            empresas</label>
          <b-progress class="" v-if="cargando2" :value="progress2" :max="100" show-progress animated>
            <b-progress-bar :value="progress2" :label="`${progress2}%`"></b-progress-bar>
          </b-progress>


          <label for="" class="mt-3" v-if="cargando3">Reporte Estado Resultados</label>
          <b-progress class="" v-if="cargando3" :value="progress3" :max="100" show-progress animated>
            <b-progress-bar :value="progress3" :label="`${progress3}%`"></b-progress-bar>
          </b-progress>


          <label for="" class="mt-3" v-if="cargando4">Reporte Estado Financieros</label>
          <b-progress class="" v-if="cargando4" :value="progress4" :max="100" show-progress animated>
            <b-progress-bar :value="progress4" :label="`${progress4}%`"></b-progress-bar>
          </b-progress>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Swal from "sweetalert2";
export default {
  name: "SolimanoLogReporteExcel",

  data() {
    return {
      Empresas: [],
      ListaAños: [
        { id: 1, año: 2015 },
        { id: 2, año: 2016 },
        { id: 3, año: 2017 },
        { id: 4, año: 2018 },
        { id: 5, año: 2019 },
        { id: 6, año: 2020 },
        { id: 7, año: 2021 },
        { id: 8, año: 2022 },
        { id: 9, año: 2023 },
        { id: 10, año: 2024 },
        { id: 11, año: 2025 }

      ],

      empresaRuc: "",
      periodo: "",
      cargando: false,
      cargando1: false,
      cargando2: false,
      cargando3: false,
      cargando4: false,

      value: 0,
      max: 100,
      progress: 0,
      max1: 100,
      progress1: 0,
      max2: 100,
      progress2: 0,
      max3: 100,
      progress3: 0,
      max4: 100,
      progress4: 0,
      isdisabled: false
    };
  },

  mounted() { },
  computed: {
    años() {
      const inicio = 2021; // año desde donde quieres empezar
      const actual = new Date().getFullYear();

      return Array.from(
        { length: actual - inicio + 1 },
        (_, i) => {
          const year = inicio + i;
          return {
            value: year.toString(),
            label: year.toString()
          };
        }
      );
    },

  },

  created() {
    this.apiEmpresa();
  },

  methods: {
    apiEmpresa() {
      this.axios.get(`Empresa/ListaEmpresa`).then((r) => {
        console.log(r.data);
        this.Empresas = r.data;
      });
    },

    /*  descargarReporte() {

      
        this.cargando =true

      // Realizar la solicitud Axios cuando se hace clic en el botón
      this.axios.get(`ReportesExcel/ReporteSaldoxPeriodo?rucEmpresa=${this.empresaRuc}&ejercicio=${this.periodo}`, {
        responseType: 'blob', // Indica a Axios que la respuesta es un archivo binario
        onDownloadProgress: progressEvent => {
      const percentCompleted = Math.round((progressEvent.loaded * 100) / progressEvent.total);
      console.log(`Progreso: ${percentCompleted}%`);
    }
      })
      .then(response => {
        console.log(response)
          // Crear un enlace temporal para descargar el archivo
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'reporte.xlsx'); // Nombre del archivo
          document.body.appendChild(link);
          link.click();

          // Limpiar el enlace y liberar recursos
          window.URL.revokeObjectURL(url);

          this.cargando =false

        })
        .catch(error => {
          console.error('Error al descargar el reporte:', error);
        });
    },*/

    descargarReporte() {
      this.cargando = true;
      this.isdisabled = true
      this.progress = 0

      const interval = setInterval(() => {
        if (this.progress < 100) {
          this.progress += 1;
        } else {
          clearInterval(interval);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se Descargo Excel",
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            this.cargando = false;
          }, 2000);
        }
      }, 1000);

      this.axios
        .get(
          `ReportesExcel/ReporteSaldoxPeriodo?rucEmpresa=${this.empresaRuc}&ejercicio=${this.periodo}`,
          {
            responseType: "blob", // Indica a Axios que la respuesta es un archivo binario
            onDownloadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              console.log(`Descargando... ${percentCompleted}% completado`);
              this.progress = percentCompleted; // Actualizar el progreso en tiempo real
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.isdisabled = false
          // Crear un enlace temporal para descargar el archivo
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "reporte.xlsx"); // Nombre del archivo
          document.body.appendChild(link);
          link.click();

          // Limpiar el enlace y liberar recursos
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error al descargar el reporte:", error);
        });
    },

    descargarReporte1() {
      this.cargando1 = true;
      this.isdisabled = true
      this.progress1 = 0
      const interval = setInterval(() => {
        if (this.progress1 < 100) {
          this.progress1 += 1;
        } else {
          clearInterval(interval);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se realizó la descarga",
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            this.cargando1 = false;
          }, 2000);
        }
      }, 1000);

      // Realizar la solicitud Axios cuando se hace clic en el botón
      this.axios
        .get(
          `ReportesExcel/ReporteSaldoxPeriodoAgrupado?rucEmpresa=${this.empresaRuc}&ejercicio=${this.periodo}`,
          {
            responseType: "blob", // Indica a Axios que la respuesta es un archivo binario
            onDownloadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              console.log(`Descargando... ${percentCompleted}% completado`);
              this.progress1 = percentCompleted; // Actualizar el progreso en tiempo real
            },
          }
        )
        .then((response) => {
          this.isdisabled = false

          // Crear un enlace temporal para descargar el archivo
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "reporteSaldo.xlsx"); // Nombre del archivo
          document.body.appendChild(link);
          link.click();

          // Limpiar el enlace y liberar recursos
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error al descargar el reporte:", error);
        });
    },

    descargarReporte2() {
      this.cargando2 = true;
      this.isdisabled = true
      this.progress2 = 0

      const interval = setInterval(() => {
        if (this.progress2 < 100) {
          this.progress2 += 1;
        } else {
          clearInterval(interval);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se Descargo Excel",
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            this.cargando2 = false;
          }, 2000);
        }
      }, 1000);
      // Realizar la solicitud Axios cuando se hace clic en el botón
      this.axios
        .get(
          `ReportesExcel/ReporteSaldoxPeriodoAgrupadoEmpresa?ejercicio=${this.periodo}`,
          {
            responseType: "blob",
            onDownloadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              console.log(`Descargando... ${percentCompleted}% completado`);
              this.progress2 = percentCompleted; // Actualizar el progreso en tiempo real
            },
          }
        )
        .then((response) => {
          this.isdisabled = false

          // Crear un enlace temporal para descargar el archivo
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "reporteSaldoXempresa.xlsx"); // Nombre del archivo
          document.body.appendChild(link);
          link.click();

          // Limpiar el enlace y liberar recursos
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error al descargar el reporte:", error);
        });
    },


    descargarReporte3() {
      this.cargando3 = true;
      this.isdisabled = true
      this.progress3 = 0

      const interval = setInterval(() => {
        if (this.progress3 < 100) {
          this.progress3 += 1;
        } else {
          clearInterval(interval);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se Descargo Excel",
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            this.cargando3 = false;
          }, 2000);
        }
      }, 1000);

      this.axios
        .get(
          `ReportesExcel/ReporteSaldoxPeriodoAgrupadoEEFF?rucEmpresa=${this.empresaRuc}&ejercicio=${this.periodo}`,
          {
            responseType: "blob", // Indica a Axios que la respuesta es un archivo binario
            onDownloadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              console.log(`Descargando... ${percentCompleted}% completado`);
              this.progress3 = percentCompleted; // Actualizar el progreso en tiempo real
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.isdisabled = false
          // Crear un enlace temporal para descargar el archivo
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "reportenuevo.xlsx"); // Nombre del archivo
          document.body.appendChild(link);
          link.click();

          // Limpiar el enlace y liberar recursos
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error al descargar el reporte:", error);
        });
    },

    descargarReporte4() {
      this.cargando4 = true;
      this.isdisabled = true
      this.progress4 = 0

      const interval = setInterval(() => {
        if (this.progress4 < 100) {
          this.progress4 += 1;
        } else {
          clearInterval(interval);
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se Descargo Excel",
            showConfirmButton: false,
            timer: 1500,
          });
          setTimeout(() => {
            this.cargando4 = false;
          }, 2000);
        }
      }, 1000);

      this.axios
        .get(
          `ReportesExcel/ReporteSaldoxPeriodoAgrupadoEERR?rucEmpresa=${this.empresaRuc}&ejercicio=${this.periodo}`,
          {
            responseType: "blob", // Indica a Axios que la respuesta es un archivo binario
            onDownloadProgress: (progressEvent) => {
              const percentCompleted = Math.round(
                (progressEvent.loaded * 100) / progressEvent.total
              );
              console.log(`Descargando... ${percentCompleted}% completado`);
              this.progress4 = percentCompleted; // Actualizar el progreso en tiempo real
            },
          }
        )
        .then((response) => {
          console.log(response);
          this.isdisabled = false
          // Crear un enlace temporal para descargar el archivo
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "reportenuevo2.xlsx"); // Nombre del archivo
          document.body.appendChild(link);
          link.click();

          // Limpiar el enlace y liberar recursos
          window.URL.revokeObjectURL(url);
        })
        .catch((error) => {
          console.error("Error al descargar el reporte:", error);
        });
    },
  },
};
</script>

<style scoped>
.tamaño {
  font-size: 0.65rem;
}
</style>
